export const facebookText = {
  en: {
    subtitle: "Social Community",
    title: "Follow Our Journey",
    highlight: "on Facebook",
    desc: "Stay updated with career insights, real client stories, and practical guidance to help you move forward with clarity and confidence.",
    cta: "Visit Facebook Page",
    footer: "Connect with us for updates & insights",
    pageName: "Tiffany Bui Career Counsellor",
    pageLabel: "Official Facebook Page",
  },

  vi: {
    subtitle: "Cộng Đồng",
    title: "Theo Dõi Hành Trình",
    highlight: "trên Facebook",
    desc: "Cập nhật những chia sẻ nghề nghiệp, câu chuyện thực tế và hướng dẫn giúp bạn rõ ràng và tự tin hơn trong hành trình của mình.",
    cta: "Xem Trang Facebook",
    footer: "Kết nối để nhận thêm chia sẻ & cập nhật",
    pageName: "Tiffany Bui Career Counsellor",
    pageLabel: "Trang Facebook chính thức",
  },
};
